<template>
  <el-dropdown trigger="click" @command="handleSetSize" >
    <div >
      <!-- <svg-icon class-name="size-icon" icon-class="size" /> -->
      <FontIcon type='material-icons' class='lu-click' name='text_fields' size='xlarge' />
    </div>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item v-for="item of sizeOptions" :key="item.value" :disabled="size===item.value" :command="item.value">
        {{item.label }}
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
import FontIcon from '@/components/FontIcon'
import { mapGetters } from 'vuex';

export default {
  components: { FontIcon },
  data() {
    return {
      sizeOptions: [
        { label: 'Large', value: 'large' },
        { label: 'Default', value: 'base' },
        { label: 'Small', value: 'small' }
        // { label: 'small', value: 'mini' }
      ]
    }
  },
  computed: {
    ...mapGetters([ 'size' ]),
    sizeFont: {
      get() {
        return this.$store.state.app.size
      },
      set(size) {
        this.$ELEMENT.size = size
        this.$store.dispatch('app/setSize', size)
        this.refreshView()
        this.$message({
          message: 'Switch Size Success',
          type: 'success'
        })
      }
    }
  },
  methods: {
    handleSetSize(size) {
      this.$ELEMENT.size = size
      this.$store.dispatch('app/setSize', size)
      this.refreshView()
      this.$message({
        message: 'Switch Size Success',
        type: 'success'
      })
    },
    refreshView() {
      // In order to make the cached page re-rendered
      this.$store.dispatch('tagsView/delAllCachedViews', this.$route)

      const { fullPath } = this.$route

      this.$nextTick(() => {
        this.$router.replace({
          path: '/redirect' + fullPath
        })
      })
    }
  }

}
</script>

<style lang='scss' scoped>

</style>